import type { BuildInfo } from '@common/models/build-info.model';

export const buildInfo: BuildInfo = {
    commitSHA: 'f3fde62d790a412b649578ccae81ae0d24f8b1c3',
    branch: 'main',
    deployEnv: 'prod',
    version: '1.2.12',
    dateFormatted: '2025-05-12--22-41',
    dateISOString: '2025-05-12T22:41:32.982Z',
};
